import textInputSchema from './textInputSchema';
import dateSchema from './dateSchema';
import getOrganization from './getOrganization';
import getLogo from './getLogo';
import getOrganizationDetails from './getOrganizationDetails';
import getRoleDetails from './getRoleDetails';
import contentEditableDivSchema from './contentEditableDivSchema';
import unorderedList from './unorderedList';
import listItem from './listItem';
import getScore from './getScore';
import pureTextSchema from './pureText';

export default (params) => {
  const { preTag } = params;

  return {
    blocks: {
      [`${preTag}_organization`]: getOrganization(params),
      [`${preTag}_organization_details`]: getOrganizationDetails(params),
      [`${preTag}_logo`]: getLogo(params),
      [`${preTag}_image`]: { isVoid: true },
      [`${preTag}_organization_name`]: textInputSchema,
      [`${preTag}_organization_address`]: textInputSchema,
      [`${preTag}_role_details`]: getRoleDetails(params),
      [`${preTag}_test_title`]: textInputSchema,
      [`${preTag}_cgpa`]: getScore({ tag: `${preTag}_cgpa` }),
      [`${preTag}_cgpa_min`]: pureTextSchema,
      [`${preTag}_cgpa_max`]: pureTextSchema,
      [`${preTag}_date`]: dateSchema,
      [`${preTag}_test_description`]: contentEditableDivSchema,
      unordered_list: unorderedList,
      list_item: listItem,
      paragraph: { nodes: [{ match: { object: 'text' } }] },
    },
  };
};
